(function () {
  const TEASER_SELECTOR = 'button[data-testid="form-teaser"]';
  const IMAGE_URL = window.MOUVE_TEASER_IMAGE_URL;

  if (!IMAGE_URL) return;

  function findTeaser() {
    const roots = [document];

    while (roots.length) {
      const root = roots.shift();

      const teaser = root.querySelector?.(TEASER_SELECTOR);

      if (teaser) {
        return teaser;
      }

      root.querySelectorAll?.('*').forEach((element) => {
        if (element.shadowRoot) {
          roots.push(element.shadowRoot);
        }
      });
    }

    return null;
  }

  function customizeTeaser() {
    const teaser = findTeaser();

    if (!teaser) return;

    const shadowRoot = teaser.getRootNode();

    if (!shadowRoot) return;

    let style = shadowRoot.querySelector('#mouve-form-teaser-style');

    if (!style) {
      style = document.createElement('style');
      style.id = 'mouve-form-teaser-style';

      style.textContent = `
        [data-testid="form-teaser"] {
          width: 70px !important;
          height: 70px !important;
          min-width: 70px !important;
          min-height: 70px !important;
          max-width: 70px !important;
          max-height: 70px !important;

          padding: 0 !important;
          margin: 0 !important;

          background: transparent !important;
          border: 0 !important;
          box-shadow: none !important;
          border-radius: 0 !important;

          display: flex !important;
          align-items: center !important;
          justify-content: center !important;

          position: relative !important;
          overflow: visible !important;

          font-size: 0 !important;
          color: transparent !important;

          transform: translateX(-12px) !important;
        }

        [data-testid="form-teaser"] * {
          font-size: 0 !important;
        }

        [data-testid="form-teaser"] .mouve-teaser-image {
          width: 70px !important;
          height: 70px !important;
          min-width: 70px !important;
          min-height: 70px !important;
          max-width: 70px !important;
          max-height: 70px !important;

          object-fit: contain !important;
          display: block !important;

          pointer-events: none !important;
          flex-shrink: 0 !important;
        }

        [data-testid="form-teaser"] [aria-label*="Close"],
        [data-testid="form-teaser"] [aria-label*="close"] {
          position: absolute !important;

          top: -2px !important;
          right: -2px !important;

          width: 14px !important;
          height: 14px !important;
          min-width: 14px !important;
          min-height: 14px !important;

          padding: 0 !important;
          margin: 0 !important;

          z-index: 20 !important;

          font-size: initial !important;
          color: initial !important;
        }

        @media (max-width: 749px) {
          [data-testid="form-teaser"] {
            width: 76px !important;
            height: 76px !important;
            min-width: 76px !important;
            min-height: 76px !important;
            max-width: 76px !important;
            max-height: 76px !important;

            transform: translateX(-16px) !important;
          }

          [data-testid="form-teaser"] .mouve-teaser-image {
            width: 76px !important;
            height: 76px !important;
            min-width: 76px !important;
            min-height: 76px !important;
            max-width: 76px !important;
            max-height: 76px !important;
          }
        }
      `;

      shadowRoot.appendChild(style);
    }

    const closeElement = teaser.querySelector(
      '[aria-label*="Close"], [aria-label*="close"]'
    );

    let closeButton = null;

    if (closeElement) {
      closeButton =
        closeElement.tagName === 'BUTTON'
          ? closeElement
          : closeElement.closest('button');
    }

    let image = teaser.querySelector('.mouve-teaser-image');

    if (!image) {
      image = document.createElement('img');

      image.className = 'mouve-teaser-image';
      image.src = IMAGE_URL;
      image.alt = 'MOUVE';
      image.setAttribute('aria-hidden', 'true');

      teaser.insertBefore(image, teaser.firstChild);
    }

    [...teaser.children].forEach((child) => {
      if (child === image) return;

      if (closeButton && (child === closeButton || child.contains(closeButton))) {
        return;
      }

      child.style.display = 'none';
    });

    if (closeButton) {
      closeButton.style.display = 'flex';
    }
  }

  customizeTeaser();

  const observer = new MutationObserver(() => {
    customizeTeaser();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  setInterval(customizeTeaser, 1000);
})();